'use strict';

const WISHLIST_KEY = 'user_wishlist_product_ids';
const wishlist = require('../product/wishlist');
const productTileRemoveWishlistForm = wishlist.methods.productTileRemoveWishlistForm;

const initWishlistState = () => {
    $(document).on('wishlist:check', function () {
        const storedPIDs = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
        $('.add-to-wishlist-form').each(function () {
            const $form = $(this);
            if ($form.length) {
                const productId = $form.find('input[name="pid"]').val();
                const isInWishlist = storedPIDs.includes(productId);
                if (isInWishlist) {
                    $form.find('.wishlist-wrapper').addClass('added-to-wishlist');
                    $form.attr('action', $form.attr('action').replace('Wishlist-AddProduct', 'Wishlist-RemoveProduct'));
                } else {
                    $form.find('.wishlist-wrapper').removeClass('added-to-wishlist');
                }
            }
        });
    });
    productTileRemoveWishlistForm();
    if ($('.add-to-wishlist-form').length) {
        $.ajax({
            url: window.wishlistURL,
            type: 'get',
            dataType: 'json',
            data: {
                pageSize: 999999,
                pageNumber: 1,
                publicView: false,
            },
            success: function (data) {
                if (!data || !data.list.items) return;
                const wishlistPIDs = data.list.items.map((item) => item.pid);
                localStorage.setItem(WISHLIST_KEY, JSON.stringify(wishlistPIDs));
                $(document).trigger('wishlist:check');
            },
        });
    }
};

module.exports = {
    initWishlistState,
};
